export enum ProjectChangesSettlementStatus {
  CHANGE_SETTLEMENT_SETTLED = 'settled',
  CHANGE_SETTLEMENT_NOT_SETTLED = 'unsettled',
  CHANGE_SETTLEMENT_NONE = 'none',
}
